import { Box, Stack } from '@mantine/core';
import { GetEvChargingStationResponse } from 'api/actions/get-ev-charging-station/get-ev-charging-station-response';
import { GetEvChargingStationLiveStatusResponse } from 'api/actions/get-ev-charging-station-live-status/get-ev-charging-station-live-status-response';
import theme from 'theme';
import AvailableStationCard from 'pages/ev-charging-station/components/AvailableStationCard';
import ChargingStationCard from 'pages/ev-charging-station/components/ChargingStationCard';

export type StationLiveStatus = GetEvChargingStationLiveStatusResponse;

interface StationHeaderCardProps {
  station: GetEvChargingStationResponse;
  /** Live AgeVolt status of the station, refreshed by the caller. */
  liveStatus: StationLiveStatus;
}

/**
 * Hero image plus the station status card: the live charging summary while
 * the current customer is charging, otherwise the station status and specs.
 */
export default function StationHeaderCard({ station, liveStatus }: StationHeaderCardProps) {
  return (
    <Stack gap={0} pt={16}>
      <Box
        style={{
          height: 208,
          position: 'relative',
          overflow: 'hidden',
          backgroundImage: 'url(/img/ev-charging-station.png)',
          backgroundSize: 'cover',
          backgroundPosition: 'top center',
        }}
      >
        <Box
          style={{
            position: 'absolute',
            inset: 0,
            background: `linear-gradient(to bottom, rgba(243,244,245,0) 55%, ${theme.colors?.gray?.[0]} 100%)`,
          }}
        />
      </Box>
      {liveStatus.status === 'charging' && liveStatus.activeSession ? (
        <ChargingStationCard
          station={station}
          activeSession={liveStatus.activeSession}
          maxPowerKw={liveStatus.maxPowerKw}
        />
      ) : (
        <AvailableStationCard station={station} liveStatus={liveStatus} />
      )}
    </Stack>
  );
}
